import { useState } from 'react';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import { APIGetTetraederToken } from '../api/partner/Partner';
import { formFields } from '../components/authentication/formFields';
import { LiaExternalLinkAltSolid } from 'react-icons/lia';
import { v4 } from 'uuid';

export const Signup = () => {
    const queryParameters = new URLSearchParams(window.location.search);
    const cityId = queryParameters.get('city_id');
    const [type, setType] = useState('user');
    const [message, setMessage] = useState();
    const [signupHandled, setSignupHandled] = useState(false);
    const source = cityId ? JSON.stringify({
        'city_id': cityId,
        'source': 'tetraeder',
    }) : '';
    const companyId = v4();

    const navigate = useNavigate();



    const handleUserState = async (user) => {
        try {
            if (signupHandled) {
                return;
            }
            if (!cityId) {
                navigate('/');
                return;
            }
            const token = await APIGetTetraederToken(user.attributes['custom:companyId'], cityId);
            if (token) {
                setMessage(`Ihr Token wurde erfolgreich erstellt.`);
            } else {
                setMessage(`Token konnte nicht erstellt werden.`);
            }
            setSignupHandled(true);
        } catch (error) {
            setMessage('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
            setSignupHandled(true);
        }
    };

    return (
        <div className='h-full py-4'>
            <Authenticator 
                initialState="signUp"
                formFields={formFields}
                components={{
                    SignUp: {
                        FormFields() {
                            return (
                                <div className={'signupLegal'}>
                                    <div className='amplify-flex amplify-field amplify-textfield'>
                                        <label className='amplify-label' htmlFor='type'>
                                            Art des Zugangs
                                        </label>
                                        <div className='amplify-field-group amplify-field-group-horizontal'>
                                            <select
                                                id='type'
                                                name='custom:type'
                                                className='border border-gray-800 rounded-md focus:outline-none focus:ring-indigo-300 focus:border-indigo-300'
                                                style={{
                                                    width: '200px',
                                                    padding: '8px 16px',
                                                }}
                                                required={true}
                                                defaultValue={type}
                                                onChange={(e) => {
                                                    e.preventDefault();
                                                    setType(e.target.value);
                                                }}>
                                                <option value='---' disabled>
                                                    Bitte wählen
                                                </option>
                                                <option value='user'>
                                                    Für Kommunen / Gebietskörperschaften
                                                </option>
                                                <option value='creator'>
                                                    Für Planersteller / Planungsbüros
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    {type === 'creator' && (
                                        <div className='amplify-flex amplify-field amplify-textfield'>
                                            <label className='amplify-label' htmlFor='organisation'>
                                                Unternehmen
                                            </label>
                                            <div className='amplify-flex amplify-field-group amplify-field-group--horizontal'>
                                                <input
                                                    id='organisation'
                                                    name='custom:company'
                                                    type='text'
                                                    placeholder='Unternehmen eingeben'
                                                    className='amplify-input amplify-field-group__control'
                                                    required={true}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {type === 'user' && (
                                        <>
                                            <div className='amplify-flex amplify-field amplify-textfield'>
                                                <label className='amplify-label' htmlFor='community'>
                                                    Gemeinde Name
                                                </label>
                                                <div className='amplify-flex amplify-field-group amplify-field-group--horizontal'>
                                                    <input
                                                        id='community'
                                                        name='custom:community'
                                                        type='text'
                                                        placeholder='Gemeinde Name eingeben'
                                                        className='amplify-input amplify-field-group__control'
                                                        required={true}
                                                    />
                                                </div>
                                            </div>
                                            <div className='amplify-flex amplify-field amplify-textfield'>
                                                <label className='amplify-label' htmlFor='communitykey'>
                                                    Gemeinde Schlüssel
                                                </label>
                                                <div className='amplify-flex amplify-field-group amplify-field-group--horizontal'>
                                                    <input
                                                        id='communitykey'
                                                        name='custom:communitykey'
                                                        type='text'
                                                        placeholder='Gemeinde Schlüssel eingeben'
                                                        className='amplify-input amplify-field-group__control'
                                                        required={true}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <Authenticator.SignUp.FormFields />
                                    <div className='hidden'>
                                        <div className='amplify-flex amplify-field-group amplify-field-group--horizontal'>
                                            <input
                                                id='custom:source'
                                                name='custom:source'
                                                type='text'
                                                defaultValue={source}
                                                placeholder='Quelle eingeben'
                                                className='amplify-input amplify-field-group__control'
                                                required={true}
                                            />
                                        </div>
                                        <div className='amplify-flex amplify-field-group amplify-field-group--horizontal'>
                                            <input
                                                id='custom:companyId'
                                                name='custom:companyId'
                                                type='text'
                                                defaultValue={companyId}
                                                placeholder='Quelle eingeben'
                                                className='amplify-input amplify-field-group__control'
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className='relative flex mt-8 pt-8 border-t border-gray-500 gap-x-3'>
                                        <div className='flex h-6 items-center'>
                                            <input
                                                id='imprint'
                                                name='imprint'
                                                required
                                                type='checkbox'
                                                className='h-4 w-4 rounded border-gray-900 text-indigo-600 focus:ring-indigo-600'
                                            />
                                        </div>
                                        <div className='text-sm leading-6'>
                                            <a
                                                href={'https://www.xplanung24.de/agb'}
                                                target={'_blank'}
                                                htmlFor='candidates'
                                                className='font-bold flex text-gray-900'
                                                rel='noreferrer'>
                                                Nutzungsbedingungen <LiaExternalLinkAltSolid />
                                            </a>
                                            <p className='text-gray-900'>
                                                Ich habe die Nutzungsbedingungen gelesen und akzeptiere
                                                diese.
                                            </p>
                                        </div>
                                    </div>
                                    <div className='relative flex mt-4 gap-x-3'>
                                        <div className='flex h-6 items-center'>
                                            <input
                                                id='privacy'
                                                required
                                                name='privacy'
                                                type='checkbox'
                                                className='h-4 w-4 rounded border-gray-900 text-indigo-600 focus:ring-indigo-600'
                                            />
                                        </div>
                                        <div className='text-sm leading-6'>
                                            <a
                                                href={'https://www.xplanung24.de/datenschutz'}
                                                target={'_blank'}
                                                htmlFor='privacy'
                                                className='font-bold flex text-gray-900'
                                                rel='noreferrer'>
                                                Datenschutzbestimmung <LiaExternalLinkAltSolid />
                                            </a>
                                            <p className='text-gray-900'>
                                                Ich habe die Datenschutzbestimmung gelesen und
                                                akzeptiere diese.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        },
                    }
                }}
            >
                {({user }) => {
                    handleUserState(user);
                    if (!message) {
                        return (
                            <div className='signupSuccess'>
                                <h1 className='text-2xl font-bold'>Erfolgreich Eingeloggt</h1>
                                <p className='text-lg'>Bitte warten Sie einen Moment.</p>
                            </div>
                        )
                    }
                    return (
                        <div className='signupSuccess'>
                            <h1 className='text-2xl font-bold'>Erfolgreich Eingeloggt</h1>
                            <p className='text-lg'>{message}</p>
                            <p className='text-lg'>Sie können das Fenster nun schließen.</p>
                        </div>
                )}}
            </Authenticator>
        </div>
    )
}